import { create } from 'zustand'

interface CategoryState {
  selectedCategoryId: number | null
  selectedCategoryName: string | null
  setSelectedCategory: (id: number, name: string) => void
}

export const useCategoryStore = create<CategoryState>((set) => ({
  selectedCategoryId: null,
  selectedCategoryName: null,
  setSelectedCategory: (id, name) => set({ 
    selectedCategoryId: id,
    selectedCategoryName: name 
  }),
}))
